export const FIELD_REPORT_TEMPLATE_TYPE = 'field';
export const READING_TEMPLATE_TYPE = 'reading';

export const templateTypes = {
  field_report: FIELD_REPORT_TEMPLATE_TYPE,
  reading: READING_TEMPLATE_TYPE,
};
